/* eslint-disable */
import request from './helpers'

export function deleteCubeMonitorData (id) {
    return request ({
        url: '/api/v1/manage/cube_monitor_data/' + id + '/delete',
        method: 'delete'
    })
}

export function listCubeMonitorDataList () {
    return request ({
        url: '/api/v1/manage/cube_monitor_data/list',
        method: 'get'
    })
}

export function listCubeMonitorDataByTenantName (tenantName) {
    return request ({
        url: '/api/v1/manage/cube_monitor_data/' + tenantName + '/list',
        method: 'get'
    })
}

export function createCubeMonitorData (data) {
    return request ({
        url: '/api/v1/manage/cube_monitor_data/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function updateCubeMonitorData (data) {
    return request ({
        url: '/api/v1/manage/cube_monitor_data/update',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function generateClusterDashboardQueries (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/cluster_dashboard/generate',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function listGroupName () {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/groups/list',
        method: 'get'
    })
}

export function listDashboardsByGroupName (groupName) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/' + groupName + '/list',
        method: 'get'
    })
}

export function deleteDashboard (id) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/' + id + '/delete',
        method: 'delete'
    })
}

export function getDashboardDetail (id) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/' + id + '/detail',
        method: 'get'
    })
}

export function createDashboard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function listDashboards () {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/list',
        method: 'get'
    })
}

export function saveDashboard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/save',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function updateDashboard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/dashboard/update',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function listMyDataBases () {
    return request ({
        url: '/api/v1/manage/dashboard_service/databases/list',
        method: 'get'
    })
}

export function listMyMeasurements (database) {
    return request ({
        url: '/api/v1/manage/dashboard_service/measurement/' + database + '/list',
        method: 'get'
    })
}

export function listMeasurementFields (database, measurement) {
    return request ({
        url: '/api/v1/manage/dashboard_service/measurement/fields/' + database + '/' + measurement + '/list',
        method: 'get'
    })
}

export function listMeasurementTagValues (database, measurement, tag) {
    return request ({
        url: '/api/v1/manage/dashboard_service/measurement/tag_values/' + database + '/' + measurement + '/' + tag + '/list',
        method: 'get'
    })
}

export function listMeasurementTags (database, measurement) {
    return request ({
        url: '/api/v1/manage/dashboard_service/measurement/tags/' + database + '/' + measurement + '/list',
        method: 'get'
    })
}

export function listMetricsCardsByDashboardId (dashboardId) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/' + dashboardId + '/list',
        method: 'get'
    })
}

export function deleteMetricsCard (id) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/' + id + '/delete',
        method: 'delete'
    })
}

export function getMetricsCardDetail (id) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/' + id + '/detail',
        method: 'get'
    })
}

export function createMetricsCard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function listMetricsCards () {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/list',
        method: 'get'
    })
}

export function getMetricsDataForMetricsCard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/query',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function updateMetricsCard (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics_card/update',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function getMetricsDataFromZRMonitor (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/metrics/query',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function generateTopicDashboardQueries (data) {
    return request ({
        url: '/api/v1/manage/dashboard_service/topic_dashboard/generate',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}
